import { all, fork, call, put, takeEvery, takeLatest } from 'redux-saga/effects'

import { 
  search, 
  searchSuccess, 
  searchFailure,
  loadMore,
  loadMoreSuccess,
  loadMoreFailure 
} from '../actions';

import { searchRequest } from '../api';

function* sagaSearch({ payload }) {
  try {

    const result = yield call(searchRequest, payload);
    yield put(searchSuccess(result));

  } catch (error) {
    
    yield put(searchFailure(error));

  }
}

function* sagaSearchLoadMore({ payload }) {
  try {

    const result = yield call(searchRequest, payload);
    yield put(loadMoreSuccess(result));

  } catch (error) {

    yield put(loadMoreFailure(error));

  }
}

export default function* watcherSearch() {
  yield takeLatest(search, sagaSearch);
  yield takeEvery(loadMore, sagaSearchLoadMore);
}